import moment from "moment";

export const dateFormats = {
  localFormatLong: "DD-MM-YYYY HH:mm",
  apiFormat: "YYYY-MM-DD HH:mm"
};

const formatDateTime = (utcDate, dateFormat) => {
  
  if (utcDate) {
    return moment
      .utc(utcDate)
      .local()
      .format(dateFormat);
  }
  return null;
};

const formatDealDateTime = (utcDate, dateFormat) => {
  if (utcDate) {
    return moment
      .utc(utcDate)
      .local()
      .format(dateFormat);
  }
  return null;
};

const isoDate = date => {
  return new Date(date).toISOString();
};

const compareDate = (date1, date2) => {
  date1 = moment(date1);
  date2 = moment(date2);
  const duration = moment.duration(date1.diff(date2));
  return duration.asSeconds();
};
const formatDate = date => {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

const checkDate = date => {
  date = formatDate(date);

  return moment().isAfter(date, "hour");
};
export const dateTimeutils = {
  formatDateTime,
  isoDate,
  compareDate,
  checkDate,
  formatDealDateTime
};
